import {Component, Input, OnInit} from '@angular/core';
import { NavigateManagerService } from '../../../../core/services/navigate-manager.service';
import { SessionStorage } from '../../../../core/services/global/storage/session-storage.service';
import { StepKey } from '../../../../core/enums/step-key.enum';
import { NotificationStateService } from '../../../services/notification-state.service';
import { SectionBase } from '../../../components/section/section-base';
import { AppMode } from '../../../models/app-mode.enum';
import {ConfigurationService} from '../../../../core/services/impl/configuration/configuration.service';
import {AssetsService} from '../../../services/assets.service';
import {NotificationState} from '../../../models/notification-state';
import {isSkycash, salesChannel} from '../../../../core/utils/utils';
import {SalesChannel} from '../../../../core/consts/sales-channel.enum';
import {UrlParamsService} from '../../../../core/services/impl/url-params.service';
import {PartnerService} from '../../../services/partner.service';

@Component({
  selector: 'app-error-notify-section-web',
  templateUrl: './error-notify-section-web.component.html',
  styleUrls: ['./error-notify-section-web.component.scss']
})
export class ErrorNotifySectionWebComponent extends SectionBase implements OnInit {

  @Input() notificationState: NotificationState;

  get anchorButton(): boolean {
    return isSkycash() && this.urlParamsService.isMobileOrigin;
  }

  get redirectUrl(): string {
    if (isSkycash()) {
      return this.partnerService.skyCashExitActionUrl;
    }
    return null;
  }

  constructor(private sessionStorage: SessionStorage,
              private urlParamsService: UrlParamsService,
              private navigateManagerService: NavigateManagerService,
              private notificationStateService: NotificationStateService,
              private partnerService: PartnerService,
              public assetsService: AssetsService) {
    super();
  }

  ngOnInit() {
    this.sendMetric();
  }

  initBean() {
  }

  initControlsChanges() {
  }

  createConfig() {
  }

  backToLandingPage() {
    if (!this.anchorButton) {
      this.sessionStorage.clear();
      if (salesChannel() === SalesChannel.BANKIER) {
        window.top.location.href = 'https://www.bankier.pl/smart';
      } else {
        window.location.href = 'http://www.kioskpolis.pl';
      }
    }
  }

  backToOffer() {
    this.navigateManagerService.setAppMode(AppMode.RAW);
    this.navigateManagerService.moveToStep(StepKey.SECOND_STEP);
  }

  private sendMetric(): void {
    this.notificationStateService.sendNotificationComponentMetric('ErrorNotifySectionWebComponent', { description: this.notificationState.message });
  }
}
